import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Recent = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.0466 10.1352C3.15897 10.3496 3.13422 10.6159 2.96308 10.7871C2.73952 11.0106 2.3669 10.9799 2.21418 10.703C1.40689 9.23969 1.38791 7.56248 1.72141 6.31783C2.65053 2.8503 6.21472 0.792509 9.68225 1.72163C13.1498 2.65075 15.2076 6.21494 14.2784 9.68247C13.4998 12.5886 10.871 14.5034 7.99966 14.5016C7.72351 14.5015 7.4998 14.2775 7.49997 14.0013C7.50014 13.7252 7.72414 13.5015 8.00028 13.5016C10.4302 13.5032 12.654 11.8814 13.3125 9.42365C14.0987 6.48959 12.3575 3.47374 9.42343 2.68756C6.48937 1.90138 3.47352 3.64258 2.68734 6.57664C2.40919 7.6147 2.43055 8.96004 3.0466 10.1352ZM7.99996 4.00014C8.2761 4.00014 8.49996 4.224 8.49996 4.50014V7.75947L10.8123 9.60974C11.028 9.78226 11.0629 10.0969 10.8904 10.3125C10.7178 10.5281 10.4032 10.5631 10.1876 10.3905L7.68757 8.39016C7.56899 8.29527 7.49996 8.15163 7.49996 7.99975V4.50014C7.49996 4.224 7.72382 4.00014 7.99996 4.00014ZM1 12.5002C1 12.224 1.22386 12.0002 1.5 12.0002H3.99978L3.99988 9.50014C3.99989 9.224 4.22376 9.00015 4.4999 9.00016C4.77604 9.00017 4.99989 9.22404 4.99988 9.50018L4.99976 12.5002C4.99974 12.7763 4.77589 13.0002 4.49976 13.0002H1.5C1.22386 13.0002 1 12.7763 1 12.5002Z"
        fill={color}
      />
    </svg>
  )
})

export default Recent
